export default {
  BINOMIAL: "BINOMIAL",
  LOGISTIC: "LOGISTIC_REGRESSION",
  MIXED_MODEL: "MIXED_MODEL"
};



// WEBPACK FOOTER //
// ./src/constants/modelTypes.js